import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterPagesRoutingModule } from './footer-pages-routing.module';
import { PrivacyPolicyComponent } from './page/privacy-policy/privacy-policy.component';
import { SecurityComponent } from './page/security/security.component';
import { ServiceManagementComponent } from './page/service-management/service-management.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CoreModule } from 'src/app/core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
  declarations: [
    PrivacyPolicyComponent,
    SecurityComponent,
    ServiceManagementComponent
  ],
  imports: [
    CommonModule,
    FooterPagesRoutingModule,
    SharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgxPaginationModule,
    TooltipModule.forRoot() 
  ]
})
export class FooterPagesModule { }
